import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import Page from 'src/components/Page';
import avatar from 'src/assets/images/technician.png';

const styles = {
  root: (theme) => ({
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  }),
  imageContainer: (theme) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }),
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: (theme) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  })
};

function Unauthorized() {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page
      sx={styles.root}
      title="Giriş Yetkiniz Bulunmuyor"
    >
      <Typography
        align="center"
        variant={mobileDevice ? 'h4' : 'h1'}
      >
        Giriş Yetkiniz Bulunmuyor!...
      </Typography>

      <Box sx={styles.imageContainer}>
        <Box
          component="img"
          alt="Under development"
          sx={styles.image}
          src={avatar}
        />
      </Box>
    </Page>
  );
}

export default Unauthorized;
